import { z } from 'zod';
import { Email, HexColor, Id, IsoDate, SearchQuery } from './common';
import { InvitationStatus, UserStatus } from './enums';
/* ============================================================================
   Members & invitations (Settings → Members)
   ========================================================================== */
export const MemberSchema = z.object({
    id: Id,
    name: z.string(),
    email: z.string(),
    avatarUrl: z.string().nullable(),
    initials: z.string(),
    color: HexColor,
    status: z.enum(UserStatus),
    role: z.object({ id: Id, key: z.string(), name: z.string() }),
    workspaces: z.array(z.object({ id: Id, name: z.string() })),
    openMissionCount: z.number().int().nonnegative(),
    lastActiveAt: IsoDate.nullable(),
    createdAt: IsoDate,
});
export const MemberListQuery = SearchQuery.extend({
    status: z.enum(UserStatus).optional(),
    roleId: Id.optional(),
    workspaceId: Id.optional(),
});
export const MemberUpdateSchema = z.object({
    roleId: Id.optional(),
    workspaceIds: z.array(Id).optional(),
});
/** Remove/deactivate can reassign the person's open missions. */
export const MemberRemoveSchema = z.object({ reassignToUserId: Id.nullable() });
export const InvitationSchema = z.object({
    id: Id,
    email: z.string(),
    role: z.object({ id: Id, name: z.string() }),
    workspaces: z.array(z.object({ id: Id, name: z.string() })),
    status: z.enum(InvitationStatus),
    invitedBy: z.string(),
    expiresAt: IsoDate,
    createdAt: IsoDate,
    /** copyable accept link: shown to admins so invites work before email is live */
    acceptUrl: z.string().url().nullable(),
});
export const InviteCreateSchema = z.object({
    emails: z.array(Email).min(1).max(50),
    roleId: Id,
    workspaceIds: z.array(Id).min(1),
    message: z.string().max(500).optional(),
    sendEmail: z.boolean().default(true),
});
export const InviteCreateResultSchema = z.object({
    created: z.array(InvitationSchema),
    skipped: z.array(z.object({ email: z.string(), reason: z.enum(['already_member', 'already_invited', 'seat_limit']) })),
    seats: z.object({ used: z.number().int(), limit: z.number().int() }),
});
//# sourceMappingURL=users.js.map